import { backlinkDisplayTypeMap } from '@databases/collab/convert/to-collab';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setBacklinkDisplayType: YJSChangeHandler<
  DatabaseChangeType.SET_BACKLINK_DISPLAY_TYPE
> = ({ ydb, change }) => {
  const convertedBacklinkDisplayType = backlinkDisplayTypeMap[change.backlinkDisplayType];

  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.backlinkDisplayType = convertedBacklinkDisplayType;
  });
};
